import type { useNavigate } from 'react-router-dom';

/**
 * After saving a form: back to where it was opened from (the X there then leads on to the list), or – opened
 * directly – to `to`, replacing the form in the history. Never leaves the form reachable with "back".
 */
export function leaveForm(nav: ReturnType<typeof useNavigate>, to: string) {
  const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
  if (idx > 0) void nav(-1);
  else void nav(to, { replace: true });
}
